import * as React from 'react';
import * as classNames from 'classnames';
import { Helmet } from 'react-helmet';

import './styles.scss';
import LoadingContent from '../../Components/LoadingContent';
import { IWithOverlaysProps, withOverlays } from '../../Hocs/Overlay';
import { compose } from 'redux';
import LoadingApp from '../../Components/LoadingApp';
import Icon from '../../Components/Icon';
import Userhub, { IUserhubProps } from './Userhub';
import { Popover, PopoverInteractionKind, PopoverPosition } from '@blueprintjs/core';

export interface IFrameAdminMenuItem {
    name: string;
    href?: string;
    onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
    active: boolean;
    submenus?: Omit<IFrameAdminMenuItem, 'submenus'>[];
    pendoId?: string;
    openInNewTab?: boolean;
}

export interface IFrameAdminProps {
    /** Page title */
    title: string;
    /** Menu contents to render */
    menuitems: IFrameAdminMenuItem[];
    /** Render loader instead of frame itself */
    isLoading?: boolean;
    /** Render loader instead of content */
    isLoadingContent?: boolean;
    /** Router location to pass, use this to handle overlay closing */
    location: any;
    /** Locale string to pass */
    locale: string;
    /** Props delegated to userhub */
    userhubProps: IUserhubProps;
    /** React-router link component to use instead of HTML A tag. If defined href is passed as "to" prop. */
    link?: any;
    /** logo link href */
    logoHref: string;

    onAdmin: boolean;
}

interface IState {
}

type Props = IFrameAdminProps & IWithOverlaysProps;

class FrameAdmin extends React.Component<Props, IState> {
    static displayName: string = 'FrameAdmin';

    componentDidMount() {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.add('global-frame-admin');
        }
    }

    componentWillUnmount() {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.remove('global-frame-admin');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.props.closeOverlay('all', true);
        }
    }

    render() {
        if (this.props.isLoading) {
            return <LoadingApp />;
        }

        let Link: any = 'a';
        if (this.props.link) {
            Link = this.props.link;
        }

        return (
            <>
            <div className="frame-admin" style={{paddingBottom: this.props.onAdmin?'0px':'75px'}}>
                <Helmet>
                    <title>{this.props.title}</title>
                </Helmet>
                <div className="frame-admin-nav">
                    <div className="frame-admin-nav-limiter">
                        <div className="frame-admin-nav-area0">
                            <button
                                className="frame-admin-menubutton"
                                onClick={() => {
                                    this.props.closeOverlay('all');
                                    this.props.openOverlay('mobilemenu', false);
                                }}
                            >
                                <Icon width={16} height={16} kind="menu" />
                            </button>
                        </div>
                        <div className="frame-admin-nav-area1">
                            <Link
                                className="logo"
                                {...(this.props.link ? { to: this.props.logoHref } : { href: this.props.logoHref })}
                            >
                                <Icon width={48} height={30} kind="logo" />
                            </Link>
                        </div>
                        <div className="frame-admin-nav-area2">
                            <ul className="frame-admin-menu">
                                {this.props.menuitems.map((menuitem, index) => {
                                    return (
                                        <li key={index} id={menuitem.pendoId}>
                                            {menuitem.submenus ? (
                                                <Popover
                                                    hoverCloseDelay={0}
                                                    hoverOpenDelay={0}
                                                    interactionKind={PopoverInteractionKind.HOVER}
                                                    minimal={true}
                                                    position={PopoverPosition.BOTTOM_LEFT}
                                                    transitionDuration={0}
                                                    portalClassName="frame-admin-menu-portal"
                                                    popoverClassName="frame-admin-menu-popover"
                                                >
                                                    {menuitem.href ? (
                                                        <Link
                                                            {...(this.props.link ? { to: menuitem.href } : { href: menuitem.href })}
                                                            onClick={menuitem.onClick}
                                                            className={menuitem.active ? 'active' : ''}
                                                            {...(menuitem.openInNewTab ?  {target: "_blank" , rel: "noopener noreferrer" } : {})}
                                                        >
                                                            <span className="label">{menuitem.name}</span>
                                                            <Icon width={8} height={8} kind="arrow4-down" />
                                                        </Link>
                                                    ) : (
                                                        <a
                                                            onClick={menuitem.onClick}
                                                            className={menuitem.active ? 'active' : ''}
                                                        >
                                                            <span className="label">{menuitem.name}</span>
                                                            <Icon width={8} height={8} kind="arrow4-down" />
                                                        </a>
                                                    )}
                                                    <ul className="frame-admin-menu-drop">
                                                        {menuitem.submenus.map((sub, i) => {
                                                            return (
                                                                <li key={i} id={sub.pendoId}>
                                                                    {sub.href ? (
                                                                        <Link
                                                                            {...(this.props.link ? { to: sub.href } : { href: sub.href })}
                                                                            onClick={sub.onClick}
                                                                            className={classNames('bp3-popover-dismiss', { active: sub.active })}
                                                                            {...(sub.openInNewTab ?  {target: "_blank" , rel: "noopener noreferrer" } : {})}
                                                                        >
                                                                            {sub.name}
                                                                        </Link>
                                                                    ) : (
                                                                        <a
                                                                            onClick={sub.onClick}
                                                                            className={classNames('bp3-popover-dismiss', { active: sub.active })}
                                                                            {...(sub.openInNewTab ?  {target: "_blank" , rel: "noopener noreferrer" } : {})}
                                                                        >
                                                                            {sub.name}
                                                                        </a>
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </Popover>
                                            ) : (
                                                <Link
                                                    {...(this.props.link ? { to: menuitem.href } : { href: menuitem.href })}
                                                    onClick={menuitem.onClick}
                                                    className={menuitem.active ? 'active' : ''}
                                                >
                                                    {menuitem.name}
                                                </Link>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="frame-admin-nav-area3">
                            <Userhub {...this.props.userhubProps} />
                        </div>
                    </div>
                </div>
                {/* Hide New Standards Page: Ticket Number:- 4185893385 */}
                {<div id="betaFlag" style={{
                    backgroundColor: '#2980b9', 
                    color: 'white',
                    textAlign: 'center',
                }}>Discover ACADEMY by LQA. Launching July 2025. <a style={{
                    color: 'white',
                    textDecoration: 'underline'
                }} target='_blank' href='https://academylqa.com/'>Find out more now</a>.</div>}
                <div className="frame-admin-content">
                    {this.props.isLoadingContent ? <LoadingContent layout="flex" /> : this.props.children}
                </div>
                </div>
        </>
        );
    }
}

export default compose<React.ComponentClass<IFrameAdminProps>>(
    withOverlays
)(FrameAdmin);
